import isIRMRestricted from 'owa-mail-protection/lib/utils/isIRMRestricted';
import { ClientItem } from 'owa-mail-store';
import getItemRightsManagementRestrictions from 'owa-mail-store/lib/utils/getItemRightsManagementRestrictions';

// Disable user highlighting option when restricted by IRM (VSO 63483)
export default function shouldDisableOption(item: ClientItem): boolean {
    const itemRestrictions = getItemRightsManagementRestrictions(item);
    return isIRMRestricted(itemRestrictions);
}
